import { ROSTER_MANAGE_ALLOWED_ROLES } from '@/lib/capabilities';

/** Operation cohorts matched to the phase 2b controlled SQL readers and writers.
 * HR operational scope is tenant-wide; final approval and costs remain separate. */
export const PEOPLE_HR_ROLES = ['HR_DIRECTOR', 'HR_OFFICER'] as const;
export const PEOPLE_EVIDENCE_ROLES = ['COMPLIANCE_OFFICER', 'QUALITY_OFFICER'] as const;
export const ONBOARDING_READ_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'REGION_MANAGER',
  'FACILITY_MANAGER',
  'COORDINATOR',
  'TEAM_LEADER',
  ...PEOPLE_HR_ROLES,
] as const;
export const ONBOARDING_START_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FACILITY_MANAGER',
  'COORDINATOR',
  ...PEOPLE_HR_ROLES,
] as const;
export const ONBOARDING_NOT_STARTED_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'REGION_MANAGER',
  'FACILITY_MANAGER',
  'COORDINATOR',
  'TEAM_LEADER',
  ...PEOPLE_HR_ROLES,
] as const;
export const ONBOARDING_DOCUMENT_VERIFY_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'REGION_MANAGER',
  'FACILITY_MANAGER',
  'COORDINATOR',
  ...PEOPLE_HR_ROLES,
] as const;
export const ONBOARDING_BULK_PARSE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FACILITY_MANAGER',
  'COORDINATOR',
  'TEAM_LEADER',
  ...PEOPLE_HR_ROLES,
] as const;
export const ONBOARDING_BULK_APPLY_ROLES = ['SYSTEM_ADMIN', 'TENANT_ADMIN'] as const;
export const UNASSIGNED_TASK_REGISTER_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'COORDINATOR',
] as const;
export const LEARNING_OPERATE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'REGION_MANAGER',
  'REGION_COMPLIANCE_OFFICER',
  'FACILITY_MANAGER',
  'COORDINATOR',
  ...PEOPLE_HR_ROLES,
] as const;
export const LEARNING_EXPORT_ROLES = [...LEARNING_OPERATE_ROLES] as const;
export const POLICY_DRAFT_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FACILITY_MANAGER',
  'QUALITY_OFFICER',
  ...PEOPLE_HR_ROLES,
] as const;
export const POLICY_LIBRARY_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FACILITY_MANAGER',
  'COORDINATOR',
  ...PEOPLE_HR_ROLES,
  ...PEOPLE_EVIDENCE_ROLES,
] as const;
/** All managers can read drafts and comment; authoring retains operation-specific role rules. */
export const POLICY_DRAFT_VIEW_ROLES = [
  ...POLICY_LIBRARY_ROLES,
  ...ROSTER_MANAGE_ALLOWED_ROLES,
  'OPERATIONS_DIRECTOR',
] as const;
export function inPeopleContentCohort(
  role: string | null | undefined,
  cohort: readonly string[],
): boolean {
  return cohort.includes(String(role ?? '').toUpperCase());
}

export const POLICY_CONFIGURATION_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FACILITY_MANAGER',
  ...PEOPLE_HR_ROLES,
  'COORDINATOR',
  'QUALITY_OFFICER',
] as const;

/** Matches both answer-free SQL preview readers; grants are not inferred. */
export const LEARNING_PREVIEW_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'OWNER',
  'CEO',
  'OPERATIONS_DIRECTOR',
  'CLINICAL_LEAD',
  'REGION_MANAGER',
  'REGION_COMPLIANCE_OFFICER',
  'FACILITY_MANAGER',
  'COORDINATOR',
  'QUALITY_OFFICER',
  'TEAM_LEADER',
  'COMPLIANCE_OFFICER',
  ...PEOPLE_HR_ROLES,
] as const;
